import Client from "./Client";
// import RequestList from "./RequestList";

const Service = {
    url: 'admin/blacklist-numbers',
    getDefault(){
        return {
            id : undefined,
            number : undefined,
            block_outgoing_fax : false,
            block_incoming_fax : false,
            created_at : undefined,
            updated_at : undefined
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },

    /**
     * @params category
     * @return Request Promise
     **/
    async create(model) {
        return await Client.post(`${this.url}`, model);
    },

    /**
     * @params category
     * @return Request Promise
     **/
    async update(model) {
        return await Client.post(`${this.url}/${model.id}`, model);
    }
}

export default Service